module.exports = __webpack_public_path__ + "fonts/fa-solid-900.9822daf6837cb0d212db5bd0837b2612.woff";